import sounds from './sounds';
import actions from './actions';
import sendCommand from './base';
const web2client = {
    sounds: sounds,
    actions: actions,
    _sendCommand: sendCommand
};
export default web2client;
